import { baseApi, TAGS } from 'shared/api';

import type { BaseResponse, FiscalYearsRes } from 'models';

export const fiscalYearsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getFiscalYears: build.query<FiscalYearsRes, string>({
      query: (coopId) => ({
        url: `/cooperatives/${coopId}/fiscalyears`,
        method: 'GET',
      }),
      transformResponse: (response: BaseResponse<FiscalYearsRes>) =>
        response.Data,
      providesTags: [TAGS.FISCAL_YEARS],
    }),
  }),
});
